/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DashboardCreateRequest,
  DashboardRepresentation,
  DashboardUpdateRequest,
  WidgetCopyRequest,
  WidgetCreateRequest,
  WidgetFavoriteRequest,
  WidgetRepresentation,
  WidgetUpdateRequest,
} from '../models/index';
import {
    DashboardCreateRequestFromJSON,
    DashboardCreateRequestToJSON,
    DashboardRepresentationFromJSON,
    DashboardRepresentationToJSON,
    DashboardUpdateRequestFromJSON,
    DashboardUpdateRequestToJSON,
    WidgetCopyRequestFromJSON,
    WidgetCopyRequestToJSON,
    WidgetCreateRequestFromJSON,
    WidgetCreateRequestToJSON,
    WidgetFavoriteRequestFromJSON,
    WidgetFavoriteRequestToJSON,
    WidgetRepresentationFromJSON,
    WidgetRepresentationToJSON,
    WidgetUpdateRequestFromJSON,
    WidgetUpdateRequestToJSON,
} from '../models/index';

export interface AddWidgetToFavoritesRequest {
    widgetFavoriteRequest: WidgetFavoriteRequest;
}

export interface CopyWidgetRequest {
    dashboardKey: string;
    widgetKey: string;
    widgetCopyRequest: WidgetCopyRequest;
}

export interface CreateDashboardRequest {
    dashboardCreateRequest: DashboardCreateRequest;
}

export interface CreateWidgetRequest {
    key: string;
    widgetCreateRequest: WidgetCreateRequest;
}

export interface DeleteDashboardRequest {
    key: string;
}

export interface DeleteWidgetRequest {
    dashboardKey: string;
    widgetKey: string;
}

export interface GetDashboardByKeyRequest {
    key: string;
}

export interface GetDashboardsRequest {
    portfolioKey?: string;
}

export interface GetFavoriteWidgetsRequest {
    portfolioKey?: string;
}

export interface GetWidgetByIdRequest {
    dashboardKey: string;
    widgetKey: string;
}

export interface GetWidgetOrderRequest {
    type: string;
    key: string;
}

export interface GetWidgetsRequest {
    key: string;
}

export interface RemoveWidgetFromFavoritesRequest {
    key: string;
}

export interface SetWidgetOrderRequest {
    type: string;
    key: string;
    requestBody?: Array<string>;
}

export interface UpdateDashboardRequest {
    key: string;
    dashboardUpdateRequest: DashboardUpdateRequest;
}

export interface UpdateWidgetRequest {
    dashboardKey: string;
    widgetKey: string;
    widgetUpdateRequest: WidgetUpdateRequest;
}

/**
 * 
 */
export class DashboardsApi extends runtime.BaseAPI {

    /**
     * Create a new widget
     * Create a new widget
     */
    async addWidgetToFavoritesRaw(requestParameters: AddWidgetToFavoritesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WidgetRepresentation>> {
        if (requestParameters['widgetFavoriteRequest'] == null) {
            throw new runtime.RequiredError(
                'widgetFavoriteRequest',
                'Required parameter "widgetFavoriteRequest" was null or undefined when calling addWidgetToFavorites().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:write"]);
        }


        let urlPath = `/favorites/widgets`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WidgetFavoriteRequestToJSON(requestParameters['widgetFavoriteRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WidgetRepresentationFromJSON(jsonValue));
    }

    /**
     * Create a new widget
     * Create a new widget
     */
    async addWidgetToFavorites(widgetFavoriteRequest: WidgetFavoriteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WidgetRepresentation> {
        const response = await this.addWidgetToFavoritesRaw({ widgetFavoriteRequest: widgetFavoriteRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Copy a widget to dashboard of portfolio
     * Copy a widget
     */
    async copyWidgetRaw(requestParameters: CopyWidgetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WidgetRepresentation>> {
        if (requestParameters['dashboardKey'] == null) {
            throw new runtime.RequiredError(
                'dashboardKey',
                'Required parameter "dashboardKey" was null or undefined when calling copyWidget().'
            );
        }

        if (requestParameters['widgetKey'] == null) {
            throw new runtime.RequiredError(
                'widgetKey',
                'Required parameter "widgetKey" was null or undefined when calling copyWidget().'
            );
        }

        if (requestParameters['widgetCopyRequest'] == null) {
            throw new runtime.RequiredError(
                'widgetCopyRequest',
                'Required parameter "widgetCopyRequest" was null or undefined when calling copyWidget().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:write"]);
        }


        let urlPath = `/dashboards/{dashboardKey}/widgets/{widgetKey}/copies`;
        urlPath = urlPath.replace(`{${"dashboardKey"}}`, encodeURIComponent(String(requestParameters['dashboardKey'])));
        urlPath = urlPath.replace(`{${"widgetKey"}}`, encodeURIComponent(String(requestParameters['widgetKey'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WidgetCopyRequestToJSON(requestParameters['widgetCopyRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WidgetRepresentationFromJSON(jsonValue));
    }

    /**
     * Copy a widget to dashboard of portfolio
     * Copy a widget
     */
    async copyWidget(dashboardKey: string, widgetKey: string, widgetCopyRequest: WidgetCopyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WidgetRepresentation> {
        const response = await this.copyWidgetRaw({ dashboardKey: dashboardKey, widgetKey: widgetKey, widgetCopyRequest: widgetCopyRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Create a new dashboard
     * Create dashboard
     */
    async createDashboardRaw(requestParameters: CreateDashboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DashboardRepresentation>> {
        if (requestParameters['dashboardCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'dashboardCreateRequest',
                'Required parameter "dashboardCreateRequest" was null or undefined when calling createDashboard().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:write"]);
        }


        let urlPath = `/dashboards`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DashboardCreateRequestToJSON(requestParameters['dashboardCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DashboardRepresentationFromJSON(jsonValue));
    }

    /**
     * Create a new dashboard
     * Create dashboard
     */
    async createDashboard(dashboardCreateRequest: DashboardCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DashboardRepresentation> {
        const response = await this.createDashboardRaw({ dashboardCreateRequest: dashboardCreateRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Create a new widget for a dashboard
     * Create widget
     */
    async createWidgetRaw(requestParameters: CreateWidgetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WidgetRepresentation>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling createWidget().'
            );
        }

        if (requestParameters['widgetCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'widgetCreateRequest',
                'Required parameter "widgetCreateRequest" was null or undefined when calling createWidget().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:write"]);
        }


        let urlPath = `/dashboards/{key}/widgets`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WidgetCreateRequestToJSON(requestParameters['widgetCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WidgetRepresentationFromJSON(jsonValue));
    }

    /**
     * Create a new widget for a dashboard
     * Create widget
     */
    async createWidget(key: string, widgetCreateRequest: WidgetCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WidgetRepresentation> {
        const response = await this.createWidgetRaw({ key: key, widgetCreateRequest: widgetCreateRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Delete a dashboard
     * Delete a dashboard
     */
    async deleteDashboardRaw(requestParameters: DeleteDashboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling deleteDashboard().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:write"]);
        }


        let urlPath = `/dashboards/{key}`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a dashboard
     * Delete a dashboard
     */
    async deleteDashboard(key: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDashboardRaw({ key: key }, initOverrides);
    }

    /**
     * Delete a widget by key
     * Delete widget
     */
    async deleteWidgetRaw(requestParameters: DeleteWidgetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['dashboardKey'] == null) {
            throw new runtime.RequiredError(
                'dashboardKey',
                'Required parameter "dashboardKey" was null or undefined when calling deleteWidget().'
            );
        }

        if (requestParameters['widgetKey'] == null) {
            throw new runtime.RequiredError(
                'widgetKey',
                'Required parameter "widgetKey" was null or undefined when calling deleteWidget().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:write"]);
        }


        let urlPath = `/dashboards/{dashboardKey}/widgets/{widgetKey}`;
        urlPath = urlPath.replace(`{${"dashboardKey"}}`, encodeURIComponent(String(requestParameters['dashboardKey'])));
        urlPath = urlPath.replace(`{${"widgetKey"}}`, encodeURIComponent(String(requestParameters['widgetKey'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a widget by key
     * Delete widget
     */
    async deleteWidget(dashboardKey: string, widgetKey: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteWidgetRaw({ dashboardKey: dashboardKey, widgetKey: widgetKey }, initOverrides);
    }

    /**
     * Return a single dashboard by key
     * Return a single dashboard
     */
    async getDashboardByKeyRaw(requestParameters: GetDashboardByKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DashboardRepresentation>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling getDashboardByKey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:read"]);
        }


        let urlPath = `/dashboards/{key}`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DashboardRepresentationFromJSON(jsonValue));
    }

    /**
     * Return a single dashboard by key
     * Return a single dashboard
     */
    async getDashboardByKey(key: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DashboardRepresentation> {
        const response = await this.getDashboardByKeyRaw({ key: key }, initOverrides);
        return await response.value();
    }

    /**
     * Return all dashboards for the current users.
     * Return all dashboards
     */
    async getDashboardsRaw(requestParameters: GetDashboardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DashboardRepresentation>>> {
        const queryParameters: any = {};

        if (requestParameters['portfolioKey'] != null) {
            queryParameters['portfolioKey'] = requestParameters['portfolioKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:read"]);
        }


        let urlPath = `/dashboards`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DashboardRepresentationFromJSON));
    }

    /**
     * Return all dashboards for the current users.
     * Return all dashboards
     */
    async getDashboards(portfolioKey?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DashboardRepresentation>> {
        const response = await this.getDashboardsRaw({ portfolioKey: portfolioKey }, initOverrides);
        return await response.value();
    }

    /**
     * Get widgets marked as favorites
     * Get widgets marked as favorites
     */
    async getFavoriteWidgetsRaw(requestParameters: GetFavoriteWidgetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WidgetRepresentation>>> {
        const queryParameters: any = {};

        if (requestParameters['portfolioKey'] != null) {
            queryParameters['portfolioKey'] = requestParameters['portfolioKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:read"]);
        }


        let urlPath = `/favorites/widgets`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WidgetRepresentationFromJSON));
    }

    /**
     * Get widgets marked as favorites
     * Get widgets marked as favorites
     */
    async getFavoriteWidgets(portfolioKey?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WidgetRepresentation>> {
        const response = await this.getFavoriteWidgetsRaw({ portfolioKey: portfolioKey }, initOverrides);
        return await response.value();
    }

    /**
     * Get a single widget by key
     * Get widget
     */
    async getWidgetByIdRaw(requestParameters: GetWidgetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WidgetRepresentation>> {
        if (requestParameters['dashboardKey'] == null) {
            throw new runtime.RequiredError(
                'dashboardKey',
                'Required parameter "dashboardKey" was null or undefined when calling getWidgetById().'
            );
        }

        if (requestParameters['widgetKey'] == null) {
            throw new runtime.RequiredError(
                'widgetKey',
                'Required parameter "widgetKey" was null or undefined when calling getWidgetById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:read"]);
        }


        let urlPath = `/dashboards/{dashboardKey}/widgets/{widgetKey}`;
        urlPath = urlPath.replace(`{${"dashboardKey"}}`, encodeURIComponent(String(requestParameters['dashboardKey'])));
        urlPath = urlPath.replace(`{${"widgetKey"}}`, encodeURIComponent(String(requestParameters['widgetKey'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WidgetRepresentationFromJSON(jsonValue));
    }

    /**
     * Get a single widget by key
     * Get widget
     */
    async getWidgetById(dashboardKey: string, widgetKey: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WidgetRepresentation> {
        const response = await this.getWidgetByIdRaw({ dashboardKey: dashboardKey, widgetKey: widgetKey }, initOverrides);
        return await response.value();
    }

    /**
     * Get the widget order for a board
     * Get the widget order for a board
     */
    async getWidgetOrderRaw(requestParameters: GetWidgetOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling getWidgetOrder().'
            );
        }

        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling getWidgetOrder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:write"]);
        }


        let urlPath = `/widgetorder/{type}/{key}`;
        urlPath = urlPath.replace(`{${"type"}}`, encodeURIComponent(String(requestParameters['type'])));
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get the widget order for a board
     * Get the widget order for a board
     */
    async getWidgetOrder(type: string, key: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getWidgetOrderRaw({ type: type, key: key }, initOverrides);
        return await response.value();
    }

    /**
     * Get widgets from a dashboard by dashboard key
     * Get widgets
     */
    async getWidgetsRaw(requestParameters: GetWidgetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WidgetRepresentation>>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling getWidgets().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:read"]);
        }


        let urlPath = `/dashboards/{key}/widgets`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WidgetRepresentationFromJSON));
    }

    /**
     * Get widgets from a dashboard by dashboard key
     * Get widgets
     */
    async getWidgets(key: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WidgetRepresentation>> {
        const response = await this.getWidgetsRaw({ key: key }, initOverrides);
        return await response.value();
    }

    /**
     * Remove a widget by key from favorites
     * Remove a widget
     */
    async removeWidgetFromFavoritesRaw(requestParameters: RemoveWidgetFromFavoritesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling removeWidgetFromFavorites().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:write"]);
        }


        let urlPath = `/favorites/widgets/{key}`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove a widget by key from favorites
     * Remove a widget
     */
    async removeWidgetFromFavorites(key: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeWidgetFromFavoritesRaw({ key: key }, initOverrides);
    }

    /**
     * Set the widget order for a board
     * Set the widget order for a board
     */
    async setWidgetOrderRaw(requestParameters: SetWidgetOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling setWidgetOrder().'
            );
        }

        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling setWidgetOrder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:write"]);
        }


        let urlPath = `/widgetorder/{type}/{key}`;
        urlPath = urlPath.replace(`{${"type"}}`, encodeURIComponent(String(requestParameters['type'])));
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Set the widget order for a board
     * Set the widget order for a board
     */
    async setWidgetOrder(type: string, key: string, requestBody?: Array<string>, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setWidgetOrderRaw({ type: type, key: key, requestBody: requestBody }, initOverrides);
    }

    /**
     * Update a dashboard
     * Update a dashboard
     */
    async updateDashboardRaw(requestParameters: UpdateDashboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling updateDashboard().'
            );
        }

        if (requestParameters['dashboardUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'dashboardUpdateRequest',
                'Required parameter "dashboardUpdateRequest" was null or undefined when calling updateDashboard().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:write"]);
        }


        let urlPath = `/dashboards/{key}`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DashboardUpdateRequestToJSON(requestParameters['dashboardUpdateRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a dashboard
     * Update a dashboard
     */
    async updateDashboard(key: string, dashboardUpdateRequest: DashboardUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateDashboardRaw({ key: key, dashboardUpdateRequest: dashboardUpdateRequest }, initOverrides);
    }

    /**
     * Update a widget of a dashboard
     * Update widget
     */
    async updateWidgetRaw(requestParameters: UpdateWidgetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WidgetRepresentation>> {
        if (requestParameters['dashboardKey'] == null) {
            throw new runtime.RequiredError(
                'dashboardKey',
                'Required parameter "dashboardKey" was null or undefined when calling updateWidget().'
            );
        }

        if (requestParameters['widgetKey'] == null) {
            throw new runtime.RequiredError(
                'widgetKey',
                'Required parameter "widgetKey" was null or undefined when calling updateWidget().'
            );
        }

        if (requestParameters['widgetUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'widgetUpdateRequest',
                'Required parameter "widgetUpdateRequest" was null or undefined when calling updateWidget().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:write"]);
        }


        let urlPath = `/dashboards/{dashboardKey}/widgets/{widgetKey}`;
        urlPath = urlPath.replace(`{${"dashboardKey"}}`, encodeURIComponent(String(requestParameters['dashboardKey'])));
        urlPath = urlPath.replace(`{${"widgetKey"}}`, encodeURIComponent(String(requestParameters['widgetKey'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: WidgetUpdateRequestToJSON(requestParameters['widgetUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WidgetRepresentationFromJSON(jsonValue));
    }

    /**
     * Update a widget of a dashboard
     * Update widget
     */
    async updateWidget(dashboardKey: string, widgetKey: string, widgetUpdateRequest: WidgetUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WidgetRepresentation> {
        const response = await this.updateWidgetRaw({ dashboardKey: dashboardKey, widgetKey: widgetKey, widgetUpdateRequest: widgetUpdateRequest }, initOverrides);
        return await response.value();
    }

}
